import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CircularProgress, List, Container } from '@material-ui/core';
import { connect } from 'react-redux';
import Note from './Note';
import StandardizeNote from './StandardizeNote';
import { updateReadNotes } from '../../../helpers/api';

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Notes = props => {
  const {
    fetchData,
    isChipsClicked,
    isLoading,
    newNotes,
    notes,
    showOnlyPinned,
    setNewNotes,
    setVisibleNotes,
    user,
    userInfo,
  } = props;

  const updateRead = currNewNotes => {
    const promises = [];
    currNewNotes.forEach(unread => {
      promises.push(
        updateReadNotes({
          entityID: unread.entity,
          userVersion: unread.user_version,
          email: user.email,
        })
      );
    });
    Promise.all(promises)
      .then()
      .catch();
  };

  const handleNoteClick = note => {
    const currNewNotes = [...newNotes];
    const currNewIdx = currNewNotes.findIndex(element => element.note_id === note.note_id);
    if (currNewIdx >= 0) {
      currNewNotes.splice(currNewIdx, 1);
      setNewNotes(currNewNotes);
      updateRead([note]);
    }
  };

  const handlePin = (note, pinned) => {
    const currNewIdx = notes.findIndex(element => element.note_id === note.note_id);
    if (currNewIdx >= 0) {
      notes[currNewIdx].pinned = pinned;
      if (!pinned && showOnlyPinned) {
        setVisibleNotes(notes.filter(n => n.pinned));
      }
    }
  };

  useEffect(() => {
    if (isChipsClicked && newNotes && newNotes.length > 0) {
      setNewNotes([]);
      updateRead(newNotes);
    }
  }, [isChipsClicked]);

  return (
    <Container
      style={{
        height: 300,
        overflow: 'auto',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column-reverse',
      }}
      maxWidth={false}
      component="main"
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {isLoading ? (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      ) : notes && notes.length ? (
        <List>
          {notes.map(note => {
            if (note.standardize_note && note.standardize_note === true) {
              return (
                <StandardizeNote
                  fetchData={fetchData}
                  handleNoteClick={handleNoteClick}
                  handlePin={handlePin}
                  key={note.note_id}
                  newNotes={newNotes}
                  note={note}
                  user={user}
                  userID={userInfo?.username}
                />
              );
            }

            return (
              <Note
                fetchData={fetchData}
                handleNoteClick={handleNoteClick}
                handlePin={handlePin}
                key={note.note_id}
                newNotes={newNotes}
                note={note}
                user={user}
                userID={userInfo?.username}
              />
            );
          })}
        </List>
      ) : (
        <></>
      )}
    </Container>
  );
};

function mapStateToProps(state) {
  return {
    userInfo: state.user.userInfo,
  };
}

Notes.propTypes = {
  fetchData: PropTypes.func.isRequired,
  isChipsClicked: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  newNotes: PropTypes.array.isRequired,
  notes: PropTypes.array.isRequired,
  showOnlyPinned: PropTypes.bool.isRequired,
  setNewNotes: PropTypes.func.isRequired,
  setVisibleNotes: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, null)(Notes);
